<ion-header class="header --w-back-button --underline">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.adminModules" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title [innerHTML]="(learningModule$ | async)?.name"></ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="learning-module">
  <div class="white-wrapper">
    <div class="learning-module__header">
      <span class="learning-module__title" [innerHTML]="(learningModule$ | async)?.name"></span>
      <ion-icon
        class="learning-module__ellipsis"
        slot="icon-only"
        name="ellipsis-vertical"
        (click)="presentGeneralPopover($event)"
      ></ion-icon>
    </div>

    <div class="learning-module__content">
      <div class="learning-module__content__image">
        <img [src]="(learningModule$ | async)?.imageUrl" />
      </div>
      <div
        class="learning-module__content__description"
        [class.--is-empty]="!(learningModule$ | async)?.description"
        [innerHTML]="(learningModule$ | async)?.description || ('ADMIN_LEARNING_MODULES.NO_DESCRIPTION' | translate)"
      ></div>
    </div>

    <div class="learning-module__challenges">
      <span
        *ngIf="!(chapters$ | async)?.length && !(loading$ | async)"
        class="learning-module__challenges__empty"
        [innerHTML]="'ADMIN_LEARNING_MODULES.EMPTY_CHAPTERS' | translate"
      ></span>

      <ion-list class="learning-module__challenges__list">
        <ion-item
          *ngFor="let challenge of chapters$ | async; trackBy: trackBy"
          class="learning-module__challenges__list__item"
          detail="false"
          (click)="viewChapter(challenge)"
        >
          <div class="learning-module__challenges__list__item__wrapper">
            <ion-img
              *ngIf="challenge.imageUrl"
              class="learning-module__challenges__list__item__avatar"
              [src]="challenge.imageUrl"
              [alt]="challenge.name"
            ></ion-img>
            <div class="learning-module__challenges__list__item__detail">
              <span class="learning-module__challenges__list__item__detail__name" [innerHTML]="challenge.name"></span>
              <div class="learning-module__challenges__list__item__action">
                <ion-icon
                  class="learning-module__challenges__list__item__action__ellipsis"
                  slot="icon-only"
                  name="ellipsis-vertical"
                  (click)="presentChapterPopover($event, challenge)"
                ></ion-icon>
              </div>
            </div>
          </div>
        </ion-item>
      </ion-list>
    </div>
  </div>
</ion-content>
